import styled from "@emotion/styled";

import { theme } from "../../ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div<{ opened: boolean; doNotHideSupportButton: boolean }>(props => ({
    position: "fixed",
    right: 24 + (props.doNotHideSupportButton ? 60 : 0),
    bottom: 24,
    textAlign: "right",
    zIndex: 1000,
    fontSize: 12,
    opacity: props.opened ? 1 : 0.2,
}));

export const DebugActionItemTitleContainer = styled.div(props => ({
    display: "inline-block",
    width: "240px",
    position: "relative",
    zIndex: 1,
    backgroundColor: theme(props).keyPalette.panelBackgroundColor,
    border: `2px solid ${theme(props).keyPalette.panelBackgroundColor}`,
    borderRadius: "10px",
}));

export const DebugActionItemTitle = styled.span(props => ({
    fontSize: theme(props).typography.primary.fontSize.css(),
    color: "black",
}));

export const DebugActionItemCaptionAnimationContainer = styled.div(_ => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginRight: "8px",
}));

export const DebugActionItemCaptionAnimationTarget = styled.div({
    position: "relative",
});

export const DebugActionItemCaptionContainer = styled.div({
    display: "flex",
    flexDirection: "row",
});

export const DebugActionItemHotkey = styled.div(() => ({
    fontSize: "10px",
    overflow: "visible",
    width: "75px",
    height: 0,
    marginRight: "8px",
}));

export const DropUpMenu = styled.div<{ opened: boolean }>(props => ({
    display: "block",
    position: "absolute",
    bottom: props.opened ? 0 : -4,
    pointerEvents: props.opened ? "all" : "none",
    opacity: props.opened ? 1 : 0,
    right: 64,
    transition: "bottom 0.1s ease, opacity 0.1s ease",
    zIndex: 10,

    [`${DebugActionItemCaptionAnimationTarget}`]: {
        transition: "right 0.1s ease 0.1s, opacity 0.1s ease 0.1s",
        right: props.opened ? 0 : -60,
        opacity: props.opened ? 1 : 0,
    },
}));

export const BigRoundedIcon = styled.button<{ opened: boolean }>(props => ({
    display: "inline-block",
    color: theme(props).icons.color,
    border: `2px solid ${theme(props).icons.color}`,
    width: theme(props).size(6),
    height: theme(props).size(6),
    borderRadius: theme(props).size(3),
    outline: 0,
    margin: 0,
    textAlign: "center",
    boxSizing: "border-box",
    transition: "opacity 0.1s ease",

    backgroundColor: "transparent",

    ":hover": {
        backgroundColor: theme(props).keyPalette.panelBackgroundColor,
    },
}));
const smallScreen = `@media (max-height: 770px)`;

export const SmallRoundedIcon = styled.div(props => ({
    display: "inline-block",
    color: theme(props).icons.color,
    backgroundColor: props.theme.candy.keyPalette.primaryBackgroundColor,
    border: `1px solid ${theme(props).icons.color}`,
    borderRadius: 20,
    width: 35,
    height: 35,
    padding: "6px",
    textAlign: "center",
    boxSizing: "border-box",
    zIndex: 2,
    ":hover": {
        backgroundColor: theme(props).keyPalette.panelBackgroundColor,
    },
    [smallScreen]: {
        width: 32,
        height: 32,
    },
}));

export const DebugActionItem = styled.a(props => ({
    textDecoration: "none",
    display: "flex",
    flexDirection: "row",
    marginBottom: "6px",
    cursor: "pointer",
    color: theme(props).icons.color,
    minWidth: "100px",

    [smallScreen]: {
        marginBottom: "0px",
    },

    [`${DebugActionItemHotkey}`]: {
        visibility: "hidden",
    },

    ":hover": {
        [`${DebugActionItemHotkey}`]: {
            visibility: "visible",
            span: {
                backgroundColor: theme(props).keyPalette.panelBackgroundColor,
            },
        },
        [`${SmallRoundedIcon}`]: {
            backgroundColor: theme(props).keyPalette.panelBackgroundColor,
        },
    },

    ":active": {
        [`${DebugActionItemTitle}`]: {
            backgroundColor: theme(props).keyPalette.panel2BackgroundColor,
        },
        [`${SmallRoundedIcon}`]: {
            backgroundColor: theme(props).keyPalette.panel2BackgroundColor,
        },
    },
}));
